const config = {
    apiBaseUrl: process.env.REACT_APP_API_URL || 'https://localhost:7033',
    endpoints: {
        events: {
            version: '/api/Events/dataversion',
            monthly: '/api/Events/month'
        }
    },
    // How often to poll the dataversion endpoint for changes and auto-refresh the calendar
    dataVersionPollIntervalMs: 5 * 60 * 1000
};

export default config; 